import { red } from '@material-ui/core/colors';
import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core/styles';

const themeV4RTL = createMuiTheme({
  direction: 'rtl',
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      label: {
        fontFamily: 'Roboto, sans-serif',
        fontSize: '0.88rem',
        fontWeight: 500,
      },
      contained: {
        padding: '0.5rem 1.5rem',
        boxShadow: 'none',
      },
    },
    MuiInput: {
      root: {
        padding: '4px 12px',
        height: '36px',
        border: '1px solid #e8e7e7',
        borderRadius: '3px',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '16px',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.03)',
      },
      underline: {
        '&:after': { borderBottom: 'none' },
        '&:before': { borderBottom: 'none' },
        '&:hover:not($disabled):before': { borderBottom: 'none' },
      },
    },
    MuiPickersModal: {
      dialogRoot: {
        '& .MuiDialogActions-spacing > :not(:first-child)': {
          marginLeft: 0,
        },
        '& .MuiPickersCalendarHeader-switchHeader': {
          flexDirection: 'row-reverse',
        },
      },
    },
  } as any, // Cast to allow Pickers overrides
  palette: {
    primary: {
      main: '#00799b',
      dark: '#005a73',
    },
    secondary: {
      main: '#485c6e',
    },
    text: {
      primary: '#1b2024',
      secondary: '#485c6e',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
  },
  typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  }
});

export default themeV4RTL;